import './utils/sentry'

import { StyledEngineProvider } from '@mui/material'
import * as Sentry from '@sentry/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Amplify } from 'aws-amplify'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { LocalizedApp } from './components/LocalizedApp'
import { LayoutProvider } from './contexts/LayoutContext'
import { registerPmTilesProtocol } from './utils/pmtiles'

registerPmTilesProtocol()

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
      identityPoolId: import.meta.env.VITE_ID_POOL_ID,
    },
  },
})

// The map screens fan out to ~10 queries; the library defaults (staleTime 0,
// refetchOnWindowFocus) re-ran the lot on every mount and every alt-tab.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
})

const container = document.getElementById('root')
const root = createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack)
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
})

root.render(
  <HelmetProvider>
    <StyledEngineProvider injectFirst>
      <QueryClientProvider client={queryClient}>
        <LayoutProvider>
          <LocalizedApp />
        </LayoutProvider>
      </QueryClientProvider>
    </StyledEngineProvider>
  </HelmetProvider>
)
